export default __webpack_public_path__ + "static/media/MDR-Block-logo-h-Blue.f3533c52.svg";